<template>
  <div class="content">

    <settings-menu></settings-menu>
    <div class="settings-body settings-website-tab">
      <div class="settings-body-inner">

        <div class="row">
          <div class="col-md-7">
            <div class="row">
              <div class="col-md-12">
                <div class="s-block">
                  <div class="s-block-header">Your "Donate Button" Code</div>
                  <div class="s-block-body">
                    <div class="website-img-wrap">
                      <img :src="require('./donation-check.svg')" alt="">
                    </div>
                    <div class="website-code-wrap">
                      <div class="form-item">
                        <label for="website-code">Copy/Paste the code below onto your Website Pages</label>
                        <p>Place the code just before the closing <strong>&lt;/body&gt;</strong> tag</p>
                        <textarea rows="3"
                                  placeholder=""
                                  class="form-control"
                                  id="website-code"
                                  ref="websiteCode"
                                  @focus="copyCode"
                                  :value="jsTemplateV2"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">

                <div class="s-block"
                     :class="{'not-allowed': !$root.checkFeature('custom_donate_button')}"
                     name="btn-not-allowed"
                >
                  <div class="s-block-header">Customize your Button</div>
                  <div class="s-block-body customize-button">
                    <form action="">
                      <div class="switcher-container">
                        <div class="switcher-wrap">
                          <label>
                            <switches v-model="button.visible" theme="dashboard" :disabled="isUpdating"></switches>
                          </label>
                        </div>
                        <strong>Donate Button turned <span v-if="button.visible" class="on">ON</span><span v-else
                                                                                                           class="off">OFF</span></strong>
                        <p class="info">Choose whether to turn your button on/off on your website</p>
                        <div v-if="button.visible" class="line-separator"></div>
                        <div v-if="button.visible">
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-item">
                                <label>Button Text</label>
                                <emoji-picker v-model="button.text"></emoji-picker>

                                <!--                                <input type="text" class="form-control" v-model="button.text">-->
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-item">
                                <label>Button Icon</label>
                                <!--<input type="text" class="form-control" value="Heart">-->

                                <multiselect :options="icons"
                                             :class="'multiselect-icons'"
                                             v-model="buttonIcon"
                                             :close-on-select="true"
                                             :show-labels="false"
                                             :searchable="false"
                                             :allow-empty="false"
                                             :max-height="250"
                                >
                                  <template slot="singleLabel" slot-scope="props">
                                    <span :class="`glyphicon ${props.option.name}`"></span>
                                    <span class="text">{{props.option.title}}</span>
                                  </template>

                                  <template slot="option" slot-scope="props">
                                    <span :class="`glyphicon ${props.option.name}`"></span>
                                    <span class="text">{{props.option.title}}</span>
                                  </template>
                                </multiselect>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-item">
                                <label>Button Placement</label>
                                <!--<input type="text" class="form-control" value="Heart">-->

                                <multiselect :options="placements"
                                             :class="'multiselect-icons'"
                                             v-model="buttonPlacement"
                                             :close-on-select="true"
                                             :show-labels="false"
                                             :searchable="false"
                                             :allow-empty="false"
                                             :max-height="250"
                                >
                                  <template slot="singleLabel" slot-scope="props">
                                    <span :class="[props.option.icon]"></span>
                                    <span class="text">{{props.option.title}}</span>
                                  </template>

                                  <template slot="option" slot-scope="props">
                                    <span :class="[props.option.icon]"></span>
                                    <span class="text">{{props.option.title}}</span>
                                  </template>
                                </multiselect>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-item">
                                <label :for="`button-color`">Button Color</label>
                                <color-preview :color="button.background_color"
                                               uniq-id="button-color"
                                               v-model="button.background_color"/>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-item">
                                <label>Roundness of Button</label>

                                <vue-slider v-model="button.border_radius"
                                            :tooltip="'always'"
                                            :min="0"
                                            :max="40"
                                />

                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="btn-wrap">
                              <a href="#" class="btn btn-sm btn-cancel"
                                 :class="{ disabled: widgetIsChanged }"
                                 :disabled="widgetIsChanged"
                                 v-on:click.prevent="setConfig(widgetConfig, false)">Cancel</a>
                              <a href="#" class="btn btn-sm btn-sm-edit"
                                 :class="{ disabled: widgetIsChanged }"
                                 :disabled="widgetIsChanged"
                                 v-on:click.prevent="updateWidgetConfig">Save</a>
                            </div>
                          </div>
                        </div>
                      </div>

                    </form>
                  </div>
                </div>

                <div class="s-block"
                     :class="{'not-allowed': !$root.checkFeature('custom_donate_button')}"
                     name="btn-not-allowed"
                >
                  <div class="s-block-header">Pop-Up Style</div>
                  <div class="s-block-body customize-button">
                    <form action="">
                      <div class="switcher-container">
                        <div class="switcher-wrap">
                          <label>
                            <switches v-model="modal.wide_layout" theme="dashboard" :disabled="isUpdating"></switches>
                          </label>
                        </div>
                        <strong>Display Pop-Up as
                          <span v-if="modal.wide_layout" class="on">WIDE</span><span v-else
                                                                                     class="off">SMALL</span></strong>
                        <p class="info">Choose how you'd like your pop-up to display on your website</p>
                      </div>
                    </form>
                  </div>
                </div>

                <div class="s-block"
                     :class="{'not-allowed': !$root.checkFeature('custom_donate_button')}"
                     name="btn-not-allowed"
                >
                  <div class="s-block-header">Social Proof Notifications</div>
                  <div class="s-block-body customize-button">
                    <form action="">
                      <div class="switcher-container">
                        <div class="switcher-wrap">
                          <label>
                            <switches v-model="addons.donation_bubbles" theme="dashboard"
                                      :disabled="isUpdating"></switches>
                          </label>
                        </div>
                        <strong>Recent Donation Pop-Ups
                          <span v-if="addons.donation_bubbles" class="on">ON</span><span v-else
                                                                                         class="off">OFF</span></strong>
                        <p class="info">Choose whether to display recent donation pop-ups on your website</p>
                      </div>
                    </form>
                  </div>
                </div>

                <tippy v-if="!$root.checkFeature('custom_donate_button')"
                       to="btn-not-allowed"
                       arrow >
                  <div>Upgrade to Customize your Button</div>
                </tippy>

              </div>
            </div>
          </div>

          <div class="col-md-5">
            <div class="s-block">
              <div class="s-block-header">Instructions & Help</div>
              <div class="s-block-body instructions-block">
                <p><strong>Need Help? We’ll help you get everything set up</strong></p>
                <div>If you need additional help, use the buttons below:</div>
                <div style="margin-top: 29px; margin-bottom: 10px">
                  Find instructions on adding the code to your website in minutes!
                </div>
                <div class="row">
                  <div class="col-lg-5 col-md-6 col-sm-6 col-xs-6">
                    <a href="http://help.harnessapp.com/donate-button-harness-your-website"
                       class="btn btn-sm"
                       target="_blank">Instructions Guide</a>
                  </div>
                  <div class="col-lg-5 col-md-6 col-sm-6 col-xs-6">
                    <a href="http://help.harnessapp.com/donate-button-harness-your-website/check-code-status-google-chrome"
                       class="btn btn-sm" target="_blank">Check Status</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SettingsMenu from './menu.vue';
  import autosize from 'autosize';
  import donateButtonMixin from '../Pages/donate-button-mixin';
  import ColorPreview from '../ColorPreview/index.vue';
  import Switches from 'vue-switches';
  import Multiselect from 'vue-multiselect';
  import VueSlider from 'vue-slider-component';
  import 'vue-slider-component/theme/default.css';
  import {getWidgetConfig, updateWidgetConfig} from '../../utils/api';
  import EmojiPicker from '../EmojiPicker/EmojiPicker.vue';
  import {mapState} from "vuex";

  export default {
    name: 'WebsiteCode',
    mixins: [donateButtonMixin],
    metaInfo: {
      title: 'Settings - Website Code',
    },
    components: {
      SettingsMenu,
      ColorPreview,
      Switches,
      Multiselect,
      VueSlider,
      EmojiPicker,
    },
    beforeDestroy() {
      this.deleteElement('.h-widget-wrap');
      this.deleteElement('.test-script-wrap');
    },
    mounted() {
      autosize(document.querySelector('#website-code'));
      this.initWidget();
    },
    methods: {
      updateWidgetConfig() {
        this.isUpdating = true;
        updateWidgetConfig({
          'button': this.button,
          'addons': this.addons,
          'modal': this.modal,
        }).then(widgetConfig => {
          this.setConfig(widgetConfig);
          this.isUpdating = false;
          this.$message('Changes have been saved');
        }).catch(() => this.isUpdating = false);
      },
      initWidget() {
        getWidgetConfig().then(widgetConfig => {
          this.setConfig(widgetConfig);
        });
      },
      setConfig(widgetConfig, isUpdate = true) {
        this.widgetConfig = widgetConfig;
        this.button = JSON.parse(JSON.stringify(this.widgetConfig.button));
        this.addons = JSON.parse(JSON.stringify(this.widgetConfig.addons));
        this.modal = JSON.parse(JSON.stringify(this.widgetConfig.modal));

        this.buttonIcon = this.icons.reduce((res, icon) => icon.name === this.button.icon ? icon : res, this.icons[0]);
        this.buttonPlacement = this.placements.reduce(
          (res, placement) => placement.value === this.button.page_placement ? placement : res, this.placements[0]);
        if (isUpdate) {
          this.attachJsExampleV2();
        }
      },
      copyCode() {
        this.$refs.websiteCode.select();
        document.execCommand('copy');
        this.$message('Copied to clipboard!');
      },
    },
    computed: {
      ...mapState({
        activeCharityId: state => state.auth.activeCharityId,
        activeCharityInfo: state => state.charities.activeCharityInfo,
      }),
      widgetIsChanged() {
        return JSON.stringify(this.widgetConfig.button) === JSON.stringify(this.button);
      },
    },
    watch: {
      'activeCharityId'() {
        this.initWidget();
      },
      'button.visible'(newVal, oldVal) {
        if (oldVal !== null) {
          this.updateWidgetConfig();
        }
      },
      'addons.donation_bubbles'(newVal, oldVal) {
        if (oldVal !== null) {
          this.updateWidgetConfig();
        }
      },
      'modal.wide_layout'(newVal, oldVal) {
        if (oldVal !== null) {
          this.updateWidgetConfig();
        }
      },
      'buttonIcon'() {
        this.button.icon = this.buttonIcon.name === 'icon-material-outline-highlight-off' ? '' : this.buttonIcon.name;
        this.button.display_icon = !!this.button.icon;
      },
      'buttonPlacement'() {
        this.button.page_placement = this.buttonPlacement.value;
      },
    },
    data() {
      return {
        widgetConfig: null,
        button: {
          visible: null,
          text: '',
          background_color: '',
          border_radius: '',
          icon: '',
        },
        addons: {
          donation_bubbles: null,
        },
        modal: {
          wide_layout: null,
        },
        buttonIcon: null,
        buttonPlacement: null,
        placements: [
          {value: 'bottom-right', title: 'Bottom-Right', icon: 'icon-feather-arrow-down-right'},
          {value: 'bottom-left', title: 'Bottom-Left', icon: 'icon-feather-arrow-down-left'},
        ],
        icons: [
          {
            'name': 'icon-material-outline-highlight-off',
            'title': 'No Icon',
          },
          {
            'name': 'icon-material-outline-account-circle',
            'title': 'Account',
          },
          {
            'name': 'icon-material-outline-monetization-on',
            'title': 'Coin',
          },
          {
            'name': 'icon-material-outline-face',
            'title': 'Face',
          },
          {
            'name': 'icon-material-outline-school',
            'title': 'Graduation Cap',
          },
          {
            'name': 'icon-material-outline-favorite',
            'title': 'Heart',
          },
          {
            'name': 'icon-material-outline-favorite-border',
            'title': 'Heart (Outline)',
          },
          {
            'name': 'icon-material-outline-local-atm',
            'title': 'Money',
          },
          {
            'name': 'icon-material-outline-person-pin',
            'title': 'Personal Pin',
          },
          {
            'name': 'icon-material-outline-shopping-cart',
            'title': 'Shopping Cart',
          },
          {
            'name': 'icon-material-outline-star',
            'title': 'Star',
          },
          {
            'name': 'icon-material-outline-loyalty',
            'title': 'Tag Heart',
          },
        ],
        isUpdating: false,
      };
    },

  };
</script>
<style lang="sass">
  .copied-block
    border-radius: 50px
    padding: 10px 20px
    margin: 16px
    min-width: 100px
</style>

<style lang="sass">
  .customize-button
    .vue-slider
      height: 2.2px !important
      margin-top: 26px

      .vue-slider-rail
        background-color: rgba(31, 49, 74, 0.15)

      .vue-slider-process
        background-color: #0d70e3

      .vue-slider-dot-tooltip-top
        top: -6px

      .vue-slider-dot-tooltip-inner
        background-color: #ffffff
        border-color: #ffffff
        box-shadow: 1px 3px 6px 0 rgba(0, 0, 0, 0.2)
        font-size: 7.7px
        min-width: 28px
        line-height: 12px
        color: #050926
        border-radius: 2.2px

      .vue-slider-dot-handle
        box-shadow: 0 2px 13px 0 rgba(0, 0, 0, 0.22)
        border: 0.6px solid rgba(149, 159, 169, 0.2)
</style>

<style lang="sass">
  .multiselect.multiselect-icons
    &.multiselect--active
      z-index: 200
    font-size: 14px
    line-height: 19px

    .multiselect__select
      height: 34px

    .multiselect__tags
      padding: 9px 40px 8px 13px
      height: 36px
      min-height: 0
      border-color: #dfe3e9
      border-radius: 4px

    .multiselect__single
      font-size: 14px
      line-height: 19px
      padding-left: 0
      margin-bottom: 0

    .multiselect__element,
    .multiselect__single
      .text
        padding-left: 10px

    .multiselect__option--selected.multiselect__option--highlight,
    .multiselect__option--selected.multiselect__option--highlight:after,
    .multiselect__option--group-selected.multiselect__option--highlight,
    .multiselect__option--group-selected.multiselect__option--highlight:after
      background: #0d70e3

    .multiselect__tag,
    .multiselect__option--highlight,
    .multiselect__option--highlight:after,
    .multiselect__spinner:before,
    .multiselect__spinner:after
      background: #0d70e3

</style>
